<template>
	<SOSlotBase
		:bg-white="true"
	>
		<template v-slot:title-bar>
			<SOTitleBar
				:page-title="pageSetting.pageTitle"
				:type="'back'"
				@back="back"
			/>
		</template>

		<template v-slot:content>
			<div class="flex-100 p-x-20 p-y-16 w-limit">
				<div class="flex-1">
					<div class="p-d-16">
						<div class="f-regular f-14">
							<span class="f-c-midgrey">Kode Akun: </span>
							<span class="f-c-black">{{ rekening.idakun }}</span>
						</div>
						<div class="f-regular f-12 f-c-midgrey">
							Kode ini disediakan otomatis oleh sistem.
						</div>
					</div>

					<SOInputRegular
						:title="'Nama rekening bank'"
						:placeholder="'Cth: BCA Gold'"
						:validation="'alphanumeric'"
						:required="true"
						v-model="rekening.nama"
					/>
					<ErrorMessage
						class="error p-d-16"
						label="Nama rekening bank"
						:validation="$v.rekening.nama"
					/>

					<SOInputNumeric
						:title="'Nomor Rekening'"
						:placeholder="'1234567890'"
						:required="true"
						v-model="rekening.norek"
					/>
					<ErrorMessage
						class="error p-d-16"
						label="Nomor Rekening"
						:validation="$v.rekening.norek"
					/>

					<SOInputRegular
						:title="'Atas Nama'"
						:placeholder="'Rekening atas nama...'"
						:validation="'alphanumeric'"
						:required="true"
						v-model="rekening.atasNama"
					/>
					<ErrorMessage
						class="error p-d-16"
						label="Atas Nama"
						:validation="$v.rekening.atasNama"
					/>

					<SOInputRegular
						class="p-d-16"
						:title="'Keterangan (opsional)'"
						:placeholder="'Keterangan...'"
						:validation="'alphanumeric'"
						v-model="rekening.keterangan"
					/>
				</div>

				<div class="p-d-24 w-limit">
					<SOButton
						:text="'Tambahkan'"
						:primary="true"
						:full="true"
						:disable="pageSetting.btn.save.disabled"
						:loading="pageSetting.btn.save.loading"
						@action="create"
					/>
				</div>
			</div>
		</template>

		<template v-slot:modal>
			<SOSlotModal
				:modal-title="'Batal Tambah Rekening'"
				:modal-id="'modal-batal-tambah-rekening'"
				@close="closeModal"
			>
				<template v-slot:modal-body>
					<div class="f-regular f-16 f-c-black">
						Yakin ingin membatalkan pembuatan rekening bank baru?
					</div>
				</template>
				<template v-slot:modal-footer>
					<SOButton
						:text="'Ya, batal'"
						:outline="true"
						:full="true"
						:disable="pageSetting.btn.cancel.disabled"
						:loading="pageSetting.btn.cancel.loading"
						@action="backToList"
					/>
				</template>
			</SOSlotModal>
		</template>
	</SOSlotBase>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputNumeric from "@/so-components/global/input/SOInputNumeric";
import SOButton from "@/so-components/global/ui/SOButton";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import ErrorMessage from "@/component-items/ErrorMessage";
import {minLength, required} from "vuelidate/lib/validators";

export default {
	name: "RekeningBankCreate",
	components: {
		SOSlotBase,
		SOTitleBar,
		SOInputRegular,
		SOInputNumeric,
		SOButton,
		SOSlotModal,
		ErrorMessage,
	},
	data() {
		return {
			pageSetting: {
				pageTitle: "Tambah Rekening Bank",
				btn: {
					save: {
						loading: false,
						disabled: false,
					},
					cancel: {
						loading: false,
						disabled: false,
					}
				}
			},
			rekening: {
				idakun: "",
				nama: "",
				norek: "",
				atasNama: "",
				keterangan: ""
			}
		}
	},
	validations: {
		rekening: {
			nama: {
				required,
				minLength: minLength(2)
			},
			norek: {
				required,
				minLength: minLength(2)
			},
			atasNama: {
				required,
				minLength: minLength(2)
			},
		},
	},
	mounted() {
		this.getIdAkun()
		this.smartTrackingView("add_rekening_bank");

	},
	methods: {
		back() {
			$("#modal-batal-tambah-rekening").modal("show")
		},
		closeModal() {
			$("#modal-batal-tambah-rekening").modal("hide")
		},
		backToList() {
			this.$router.back()
		},
		errorValidation() {
			this.$v.rekening.nama.$touch()
			this.$v.rekening.norek.$touch()
			this.$v.rekening.atasNama.$touch()
			return this.$v.rekening.nama.$invalid ||
				this.$v.rekening.norek.$invalid ||
				this.$v.rekening.atasNama.$invalid
		},
		async getIdAkun() {
			const res = await this.$store.dispatch("rekeningBankModule/fetchRekeningBankGetIdAkun")
			if (!res.success) {
				this.$toast.error(res.err)
				return
			}
			this.rekening.idakun = res.data.idakun_keuangan_rekening
		},
		async create() {
			if (this.errorValidation()) {
				this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
				return
			}

			this.pageSetting.btn.save.loading = true
			this.pageSetting.btn.save.disabled = true
			let form = new FormData
			form.append("idakun_keuangan", this.rekening.idakun)
			form.append("nama_rekening", this.rekening.nama)
			form.append("nama_pemilik", this.rekening.atasNama)
			form.append("nomor_rekening", this.rekening.norek)
			form.append("keterangan", this.rekening.keterangan)
			const res = await this.$store.dispatch("rekeningBankModule/fetchRekeningBankCreate", form)
			this.pageSetting.btn.save.loading = false
			this.pageSetting.btn.save.disabled = false
			if (!res.success) {
				this.$toast.error(res.err)
				return
			}
			this.$toast.success(res.msg)
			await this.$store.commit("rekeningBankModule/resetRekeningBank")
			await this.$router.push({name: "RekeningBank.List"})
			this.smartTrackingClick("simpan_rekening_bank");

		}
	}
}
</script>